const scars_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].Page_1[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].Page_1[0].RadioButtonList[3]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].Page_1[0].RadioButtonList[2]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":100,
      "radioGroup":"form1[0].Page_1[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].Page_1[0].IdentifyEvidence[0]",
      "textanswer":""
   },


   {
      "question":"Does ##name## have any scars on the trunk or extremities?",
      "sub":"Region other than Head, Face or Neck",
      "type":"yesno",
      "show": true,
      "property":"scar",
      "section": {
         page: "2",
         title: "DIAGNOSIS",
         number: "1B"
      },
      "presidence":"Yes",
      "ref":12,
      "dbqName_yes":"form1[0].Page_2[0].Yes1[0]",
      "dbqName_no":"form1[0].Page_2[0].No1[0]",
      "answer":"",
   },

   {
      "question":"Right Upper Extremity",
      "sub":"Physical exam for scars on the trunk and extremities",
      "type":"scarsLoad",
      // "skip": false,
      "show": false,
      "refId": 1,
      "section": {
         page: "3",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "A"
      },
      "questions": {         
         "options":[
               {
                  "main":"Affected",
                  "dbqName":"form1[0].Page_3[0].Affected1[0]",
                  "sub":""
               },
               {
                  "main":"Not affected",
                  "dbqName":"form1[0].Page_3[0].NotAffected1[0]",
                  "sub":""
               }
            ],
            "answer":"Affected",
            "text1": "",
            "textLabel1": "Location of the Scar and number of them:",
            "dbqName1": "form1[0].Page_3[0].Specifylocation[0]",
            "dbqNameAdditional" : "form1[0].Page_3[0].Listadditionalscars[0]",
            "dbqNameScars" : [
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[0]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[0]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[1]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[4]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[2]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[1]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[3]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[3]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[4]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[2]"
               }
            ],
            "scars" : [
               {
                  "main":"1",
                  "answerLength":"",
                  "answerWidth": "",
               },
            ]
         }
   },
   {
      "question":"Right Upper Extremity",
      "sub":"Details of the scar finding for the trunk and extremities",
      "type":"scarQuestions",
      "show": false,
      "refId": 2,
      "scarsIndex":1,
      "notUnderlying":"",
      "dbqNameNotUnderlying":"form1[0].Page_5[0].TotalArea[5],form1[0].Page_5[0].RightUpper1[0]", //text,checkbox
      "underlying":"",
      "dbqNameUnderlying":"form1[0].Page_5[0].TotalArea[11],form1[0].Page_5[0].RightUpper2[0]",   //text,checkbox
      "underlyingNone": "form1[0].Page_5[0].None3[0]",
      "notUnderlyingNone": "form1[0].Page_5[0].None[0]",
      "section": {
         page: "3",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "A"
      },
      "questions": [
               {
                  "main":"Are any of the scars tender to palpation?",
                  "isUnderlying": false,
                  "dbqNameAdditional":"form1[0].Page_3[0].Listadditionalscars[1]",
                  // "additional":[],
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_3[0].Length[5]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[6]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[7]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[8]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[9]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Are any of the scars unstable upon inspection?",
                  "isUnderlying": false,
                  "dbqNameAdditional" : "form1[0].Page_3[0].Listadditionalscars[2]",
                  // "additional":[],
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_3[0].Length[10]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[11]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[12]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[13]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[14]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Do any of the scars have underlying soft tissue damage?",
                  "isUnderlying": true,
                  "dbqNameAdditional":"form1[0].Page_3[0].Listadditionalscars[3]",
                  // "additional":[],
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_3[0].Length[15]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[16]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[17]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[18]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[19]",
                        "answer" : "",
                     }
                  ]
               }
            ]
   },
//B
   {
      "question":"Left Upper Extremity",
      "sub":"Physical exam for scars on the trunk and extremities",
      "type":"scarsLoad",
      "show": false,
      "refId": 3,
      "section": {
         page: "3",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "B"
      },
      "questions": {         
         "options":[
               {
                  "main":"Affected",
                  "dbqName":"form1[0].Page_3[0].Affected2[0]",
                  "sub":""
               },
               {
                  "main":"Not affected",
                  "dbqName":"form1[0].Page_3[0].NotAffected2[0]",
                  "sub":""
               }
            ],
            "answer":"Affected",
            "text1": "",
            "textLabel1": "Location of the Scar and number of them:",
            "dbqName1": "form1[0].Page_3[0].Spcifylocationofscars[0]",
            "dbqNameAdditional" : "form1[0].Page_3[0].Listadditionalscars[4]",
            "dbqNameScars" : [
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[20]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[5]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[21]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[9]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[22]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[6]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[23]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[8]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[24]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[7]"
               }
            ],
            "scars" : [
               {
                  "main":"1",
                  "answerLength":"",
                  "answerWidth": "",
               },
            ]
         }
   },
   {
      "question":"Left Upper Extremity",
      "sub":"Details of the scar finding for the trunk and extremities",
      "type":"scarQuestions",
      "show": false,
      "refId": 4,
      "scarsIndex":1,
      "notUnderlying":"",
      "dbqNameNotUnderlying":"form1[0].Page_5[0].TotalArea[4],form1[0].Page_5[0].LeftUpper1[0]", //text,checkbox
      "underlying":"",
      "dbqNameUnderlying":"form1[0].Page_5[0].TotalArea[10],form1[0].Page_5[0].LeftUpper2[0]",   //text,checkbox
      "underlyingNone": "form1[0].Page_5[0].None3[0]",
      "notUnderlyingNone": "form1[0].Page_5[0].None[0]",
      "section": {
         page: "3",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "B"
      },
      "questions": [
               {
                  "main":"Are any of the scars tender to palpation?",
                  "isUnderlying": false,
                  "dbqNameAdditional":"form1[0].Page_3[0].Listadditionalscars[5]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_3[0].Length[25]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[26]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[27]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[28]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[29]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Are any of the scars unstable upon inspection?",
                  "isUnderlying": false,
                  "dbqNameAdditional" : "form1[0].Page_3[0].Listadditionalscars[6]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_3[0].Length[30]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[31]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[32]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[33]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[34]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Do any of the scars have underlying soft tissue damage?",
                  "isUnderlying": true,
                  "dbqNameAdditional":"form1[0].Page_3[0].Listadditionalscars[7]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_3[0].Length[35]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[36]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[37]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[38]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[39]",
                        "answer" : "",
                     }
                  ]
               }
            ]
   },
//C
   {
      "question":"Right Lower Extremity",
      "sub":"Physical exam for scars on the trunk and extremities",
      "type":"scarsLoad",
      "show": false,
      "refId": 5,
      "section": {
         page: "3",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "C"
      },
      "questions": {         
         "options":[
               {
                  "main":"Affected",
                  "dbqName":"form1[0].Page_3[0].Affected3[0]",
                  "sub":""
               },
               {
                  "main":"Not affected",
                  "dbqName":"form1[0].Page_3[0].NotAffected3[0]",
                  "sub":""
               }
            ],
            "answer":"Affected",
            "text1": "",
            "textLabel1": "Location of the Scar and number of them:",
            "dbqName1": "form1[0].Page_3[0].Spcifylocationofscars[1]",
            "dbqNameAdditional" : "form1[0].Page_3[0].Listadditionalscars[8]",
            "dbqNameScars" : [
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[40]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[10]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[41]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[14]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[42]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[11]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[43]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[13]"
               },
               {
                  "dbqNameLength":"form1[0].Page_3[0].Length[44]",
                  "dbqNameWidth":"form1[0].Page_3[0].Width[12]"
               }
            ],
            "scars" : [
               {
                  "main":"1",
                  "answerLength":"",
                  "answerWidth": "",
               },
            ]
         }
   },
   {
      "question":"Right Lower Extremity",
      "sub":"Details of the scar finding for the trunk and extremities",
      "type":"scarQuestions",
      "show": false,
      "refId": 6,
      "scarsIndex":1,
      "notUnderlying":"",
      "dbqNameNotUnderlying":"form1[0].Page_5[0].TotalArea[3],form1[0].Page_5[0].RightLower1[0]", //text,checkbox
      "underlying":"",
      "dbqNameUnderlying":"form1[0].Page_5[0].TotalArea[9],form1[0].Page_5[0].RightLower2[0]",   //text,checkbox
      "underlyingNone": "form1[0].Page_5[0].None3[0]",
      "notUnderlyingNone": "form1[0].Page_5[0].None[0]",
      "section": {
         page: "3",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "C"
      },
      "questions": [
               {
                  "main":"Are any of the scars tender to palpation?",
                  "isUnderlying": false,
                  "dbqNameAdditional":"form1[0].Page_3[0].Listadditionalscars[9]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_3[0].Length[45]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[46]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[47]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[48]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[49]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Are any of the scars unstable upon inspection?",
                  "isUnderlying": false,
                  "dbqNameAdditional" : "form1[0].Page_3[0].Listadditionalscars[10]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_3[0].Length[50]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[51]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[52]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[53]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[54]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Do any of the scars have underlying soft tissue damage?",
                  "isUnderlying": true,
                  "dbqNameAdditional":"form1[0].Page_3[0].Listadditionalscars[11]",
                  // "additional":[],
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_3[0].Length[55]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[56]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[57]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[58]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_3[0].Length[59]",
                        "answer" : "",
                     }
                  ]
               }
            ]
   },
//D   
   {
      "question":"Left Lower Extremity",
      "sub":"Physical exam for scars on the trunk and extremities",
      "type":"scarsLoad",
      "show": false,
      "refId": 7,
      "section": {
         page: "4",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "D"
      },
      "questions": {         
         "options":[
               {
                  "main":"Affected",
                  "dbqName":"form1[0].Page_4[0].Affected4[0]",
                  "sub":""
               },
               {
                  "main":"Not affected",
                  "dbqName":"form1[0].Page_4[0].NotAffected4[0]",
                  "sub":""
               }
            ],
            "answer":"Affected",
            "text1": "",
            "textLabel1": "Location of the Scar and number of them:",
            "dbqName1": "form1[0].Page_4[0].Spcifylocationofscars[0]",
            "dbqNameAdditional" : "form1[0].Page_4[0].Listadditionalscars[0]",
            "dbqNameScars" : [
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[0]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[0]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[1]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[4]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[2]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[1]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[3]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[3]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[4]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[2]"
               }
            ],
            "scars" : [
               {
                  "main":"1",
                  "answerLength":"",
                  "answerWidth": "",
               },
            ]
         }
   },
   {
      "question":"Left Lower Extremity",
      "sub":"Details of the scar finding for the trunk and extremities",
      "type":"scarQuestions",
      "show": false,
      "refId": 8,
      "scarsIndex":1,
      "notUnderlying":"",
      "dbqNameNotUnderlying":"form1[0].Page_5[0].TotalArea[2],form1[0].Page_5[0].LeftLower1[0]", //text,checkbox
      "underlying":"",
      "dbqNameUnderlying":"form1[0].Page_5[0].TotalArea[8],form1[0].Page_5[0].LeftLower2[0]",   //text,checkbox
      "underlyingNone": "form1[0].Page_5[0].None3[0]",
      "notUnderlyingNone": "form1[0].Page_5[0].None[0]",
      "section": {
         page: "4",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "D"
      },
      "questions": [
               {
                  "main":"Are any of the scars tender to palpation?",
                  "isUnderlying": false,
                  "dbqNameAdditional":"form1[0].Page_4[0].Listadditionalscars[1]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_4[0].Length[5]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[6]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[7]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[8]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[9]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Are any of the scars unstable upon inspection?",
                  "isUnderlying": false,
                  "dbqNameAdditional" : "form1[0].Page_4[0].Listadditionalscars[2]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_4[0].Length[10]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[11]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[12]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[13]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[14]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Do any of the scars have underlying soft tissue damage?",
                  "isUnderlying": true,
                  "dbqNameAdditional":"form1[0].Page_4[0].Listadditionalscars[3]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_4[0].Length[15]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[16]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[17]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[18]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[19]",
                        "answer" : "",
                     }
                  ]
               }
            ]
   },
//E
   {
      "question":"Anterior trunk",
      "sub":"Physical exam for scars on the trunk and extremities",
      "type":"scarsLoad",
      "show": false,
      "refId": 9,
      "section": {
         page: "4",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "E"
      },
      "questions": {         
         "options":[
               {
                  "main":"Affected",
                  "dbqName":"form1[0].Page_4[0].Affected5[0]",
                  "sub":""
               },
               {
                  "main":"Not affected",
                  "dbqName":"form1[0].Page_4[0].NotAffected5[0]",
                  "sub":""
               }
            ],
            "answer":"Affected",
            "text1": "",
            "textLabel1": "Location of the Scar and number of them:",
            "dbqName1": "form1[0].Page_4[0].Spcifylocationofscars[1]",
            "dbqNameAdditional" : "form1[0].Page_4[0].Listadditionalscars[4]",
            "dbqNameScars" : [
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[20]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[5]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[21]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[9]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[22]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[6]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[23]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[8]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[24]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[7]"
               }
            ],
            "scars" : [
               {
                  "main":"1",
                  "answerLength":"",
                  "answerWidth": "",
               },
            ]
         }
   },
   {
      "question":"Anterior trunk",
      "sub":"Details of the scar finding for the trunk and extremities",
      "type":"scarQuestions",
      "show": false,
      "refId": 10,
      "scarsIndex":1,
      "notUnderlying":"",
      "dbqNameNotUnderlying":"form1[0].Page_5[0].TotalArea[1],form1[0].Page_5[0].Anteriortrunk1[0]", //text,checkbox
      "underlying":"",
      "dbqNameUnderlying":"form1[0].Page_5[0].TotalArea[7],form1[0].Page_5[0].Anteriortrunk2[0]",   //text,checkbox
      "underlyingNone": "form1[0].Page_5[0].None3[0]",
      "notUnderlyingNone": "form1[0].Page_5[0].None[0]",
      "section": {
         page: "4",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "E"
      },
      "questions": [
               {
                  "main":"Are any of the scars tender to palpation?",
                  "isUnderlying": false,
                  "dbqNameAdditional":"form1[0].Page_4[0].Listadditionalscars[5]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_4[0].Length[25]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[26]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[27]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[28]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[29]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Are any of the scars unstable upon inspection?",
                  "isUnderlying": false,
                  "dbqNameAdditional" : "form1[0].Page_4[0].Listadditionalscars[6]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_4[0].Length[30]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[31]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[32]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[33]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[34]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Do any of the scars have underlying soft tissue damage?",
                  "isUnderlying": true,
                  "dbqNameAdditional":"form1[0].Page_4[0].Listadditionalscars[7]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_4[0].Length[35]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[36]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[37]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[38]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[39]",
                        "answer" : "",
                     }
                  ]
               }
            ]
   },
//F
   {
      "question":"Posterior trunk",
      "sub":"Physical exam for scars on the trunk and extremities",
      "type":"scarsLoad",
      "show": false,
      "refId": 11,
      "section": {
         page: "4",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "F"
      },
      "questions": {         
         "options":[
               {
                  "main":"Affected",
                  "dbqName":"form1[0].Page_4[0].Affected6[0]",
                  "sub":""
               },
               {
                  "main":"Not affected",
                  "dbqName":"form1[0].Page_4[0].NotAffected6[0]",
                  "sub":""
               }
            ],
            "answer":"Affected",
            "text1": "",
            "textLabel1": "Location of the Scar and number of them:",
            "dbqName1": "form1[0].Page_4[0].Spcifylocationofscars[2]",
            "dbqNameAdditional" : "form1[0].Page_4[0].Listadditionalscars[8]",
            "dbqNameScars" : [
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[40]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[10]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[41]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[14]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[42]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[11]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[43]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[13]"
               },
               {
                  "dbqNameLength":"form1[0].Page_4[0].Length[44]",
                  "dbqNameWidth":"form1[0].Page_4[0].Width[12]"
               }
            ],
            "scars" : [
               {
                  "main":"1",
                  "answerLength":"",
                  "answerWidth": "",
               },
            ]
         }
   },
   {
      "question":"Posterior trunk",
      "sub":"Details of the scar finding for the trunk and extremities",
      "type":"scarQuestions",
      "show": false,
      "refId": 12,
      "scarsIndex":1,
      "notUnderlying":"",
      "dbqNameNotUnderlying":"form1[0].Page_5[0].TotalArea[0],form1[0].Page_5[0].Posteriortrunk1[0]", //text,checkbox
      "underlying":"",
      "dbqNameUnderlying":"form1[0].Page_5[0].TotalArea[6],form1[0].Page_5[0].Posteriortrunk2[0]",   //text,checkbox
      "underlyingNone": "form1[0].Page_5[0].None3[0]",
      "notUnderlyingNone": "form1[0].Page_5[0].None[0]",
      "section": {
         page: "4",
         title: "SCARS OF THE TRUNK AND EXTREMITIES",
         number: "F"
      },
      "questions": [
               {
                  "main":"Are any of the scars tender to palpation?",
                  "isUnderlying": false,
                  "dbqNameAdditional":"form1[0].Page_4[0].Listadditionalscars[9]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_4[0].Length[45]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[46]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[47]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[48]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[49]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Are any of the scars unstable upon inspection?",
                  "isUnderlying": false,
                  "dbqNameAdditional" : "form1[0].Page_4[0].Listadditionalscars[10]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_4[0].Length[50]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[51]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[52]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[53]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[54]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Do any of the scars have underlying soft tissue damage?",
                  "isUnderlying": true,
                  "dbqNameAdditional":"form1[0].Page_4[0].Listadditionalscars[11]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_4[0].Length[55]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[56]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[57]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[58]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_4[0].Length[59]",
                        "answer" : "",
                     }
                  ]
               }
            ]
   },

   {
      "question":"Does ##name## have any scars or disfigurement of the Head, Face or Neck?",
      "sub":"Region other than Head, Face or Neck",
      "type":"yesnoouter",
      "show": true,
      "property":"disfigurement",
      "section": {
         page: "6",
         title: "SCARS OR OTHER DISFIGUREMENT OF THE HEAD, FACE OR NECK",
         number: "2A"
      },
      "presidence":"Yes",
      "outer_ref": 6,
      "dbqName_yes":"form1[0].Page_2[0].Yes1[1]",
      "dbqName_no":"form1[0].Page_2[0].No1[1]",
      "answer":"",
   },
   {
      "question":"Identify each scar or disfigurement and provide measurements",
      "sub":"Physical exam for scars on the Head, Face and Neck",
      "type":"disfigurementLoad",
      "show": false,
      "outer_refId":1,
      "section": {
         page: "6",
         title: "SCARS OR OTHER DISFIGUREMENT OF THE HEAD, FACE OR NECK",
         number: "A"
      },
      "questions": {
            "dbqNameAdditional" : "form1[0].Page_6[0].Ifadditionalscarslistusingsameformat[0]",
            "dbqNameScars" : [
               {
                  "dbqNameOpt1": "form1[0].Page_6[0].Scar1[1]",
                  "dbqNameOpt2": "form1[0].Page_6[0].Scar1[0]",
                  "dbqName1": "form1[0].Page_6[0].Location[0]",
                  "dbqNameLength":"form1[0].Page_6[0].Length[0]",
                  "dbqNameWidth":"form1[0].Page_6[0].Width[0]",
               },
               {
                  "dbqNameOpt1": "form1[0].Page_6[0].Scar2[1]",
                  "dbqNameOpt2": "form1[0].Page_6[0].Scar2[0]",
                  "dbqName1": "form1[0].Page_6[0].Location[1]",
                  "dbqNameLength":"form1[0].Page_6[0].Length[1]",
                  "dbqNameWidth":"form1[0].Page_6[0].Width[1]",
               },
               {
                  "dbqNameOpt1": "form1[0].Page_6[0].Scar3[1]",
                  "dbqNameOpt2": "form1[0].Page_6[0].Scar3[0]",
                  "dbqName1": "form1[0].Page_6[0].Location[3]",
                  "dbqNameLength":"form1[0].Page_6[0].Length[2]",
                  "dbqNameWidth":"form1[0].Page_6[0].Width[2]",
               },
               {
                  "dbqNameOpt1": "form1[0].Page_6[0].Scar4[1]",
                  "dbqNameOpt2": "form1[0].Page_6[0].Scar4[0]",
                  "dbqName1": "form1[0].Page_6[0].Location[2]",
                  "dbqNameLength":"form1[0].Page_6[0].Length[3]",
                  "dbqNameWidth":"form1[0].Page_6[0].Width[3]",
               },
               {
                  "dbqNameOpt1": "form1[0].Page_6[0].Scar5[1]",
                  "dbqNameOpt2": "form1[0].Page_6[0].Scar5[0]",
                  "dbqName1": "form1[0].Page_6[0].Location[4]",
                  "dbqNameLength":"form1[0].Page_6[0].Length[4]",
                  "dbqNameWidth":"form1[0].Page_6[0].Width[4]",
               }
            ],
            "scars" : [
               {
                  "main":"1",
                  "answerLength":"",
                  "answerWidth": "",
                  "options":[
                     {
                        "main":"Scar"
                     },
                     {
                        "main":"Disfigurement"
                     }
                  ],
                  "answer":"Scar",
                  "text1": "",
                  "textLabel1": "Location of the Scar/Disfigurement"
               },
            ]
         }
   },
   {
      "question":"Is there elevation, depression, adherence to underlying tissue, or missing underlying soft tissue?",
      "sub":"Region other than Head, Face or Neck",
      "type":"yesno",
      "show": true,
      "property":"disfigurement",
      "section": {
         page: "6",
         title: "SCARS OR OTHER DISFIGUREMENT OF THE HEAD, FACE OR NECK",
         number: "B"
      },
      "presidence":"Yes",
      "ref": 1,
      "outer_refId":2,
      "dbqName_yes":"form1[0].Page_6[0].Yes11[0]",
      "dbqName_no":"form1[0].Page_6[0].No11[0]",
      "answer":"",
   },
   {
      "question":"Please check all the apply for elevation, depression, adherence to underlying tissue, or missing underlying soft tissue",
      "sub":"Check all the apply",
      "type":"disfigureQuestions",
      "show": false,
      "refId": 1,
      "outer_refId":3,
      "scarsIndex":2,
      "underlying":"",
      "dbqNameUnderlying":"form1[0].Page_7[0].TotalArea[2]",
      "section": {
         page: "6",
         title: "SCARS OR OTHER DISFIGUREMENT OF THE HEAD, FACE OR NECK",
         number: "B"
      },
      "questions": [
               {
                  "main":"Surface contour elevated on palpation",
                  "isUnderlying": false,
                  "dbqNameAdditional":"form1[0].Page_6[0].AdditionalScars[3],form1[0].Page_6[0].ScarDisfigurement1[5]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement1[0],form1[0].Page_6[0].Elevated[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement1[2],form1[0].Page_6[0].Elevated[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement1[3],form1[0].Page_6[0].Elevated[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement1[1],form1[0].Page_6[0].Elevated[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement1[4],form1[0].Page_6[0].Elevated[0]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Surface contour depressed on palpation",
                  "isUnderlying": false,
                  "dbqNameAdditional" : "form1[0].Page_6[0].AdditionalScars[0],form1[0].Page_6[0].ScarDisfigurement2[0]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement2[5],form1[0].Page_6[0].Depressed[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement2[3],form1[0].Page_6[0].Depressed[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement2[2],form1[0].Page_6[0].Depressed[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement2[4],form1[0].Page_6[0].Depressed[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement2[1],form1[0].Page_6[0].Depressed[0]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Scar adherent to underlying tissue",
                  "isUnderlying": false,
                  "dbqNameAdditional":"form1[0].Page_6[0].AdditionalScars[2],form1[0].Page_6[0].ScarDisfigurement3[5]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement3[0],form1[0].Page_6[0].Adherent[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement3[2],form1[0].Page_6[0].Adherent[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement3[3],form1[0].Page_6[0].Adherent[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement3[1],form1[0].Page_6[0].Adherent[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement3[4],form1[0].Page_6[0].Adherent[0]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Underlying soft tissue missing",
                  "isUnderlying": true,
                  "dbqNameAdditional":"form1[0].Page_6[0].AdditionalScars[1],form1[0].Page_6[0].ScarDisfigurement4[0]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement4[5],form1[0].Page_6[0].Missing[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement4[3],form1[0].Page_6[0].Missing[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement4[2],form1[0].Page_6[0].Missing[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement4[4],form1[0].Page_6[0].Missing[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_6[0].ScarDisfigurement4[1],form1[0].Page_6[0].Missing[0]",
                        "answer" : "",
                     }
                  ]
               }
            ]
   },
   {
      "question":"Is there abnormal pigmentation or texture of the head, face, or neck?",
      "sub":"Region other than Head, Face or Neck",
      "type":"yesno",
      "show": true,
      "property":"disfigurement",
      "section": {
         page: "2",
         title: "DIAGNOSIS",
         number: "1C"
      },
      "presidence":"Yes",
      "ref": 1,
      "outer_refId":4,
      "dbqName_yes":"form1[0].Page_7[0].Yes12[0]",
      "dbqName_no":"form1[0].Page_7[0].No12[0]",
      "answer":"",
   },
   {
      "question":"Please check all the apply for abnormal pigmentation or texture of the head, face, or neck",
      "sub":"Check all the apply",
      "type":"disfigureQuestions",
      "show": false,
      "refId": 1,
      "outer_refId":5,
      "scarsIndex":4,
      "abnormalTexture":"",
      "dbqNameAbnormalTexture":"form1[0].Page_7[0].TotalArea[0]",
      "inflexible":"",
      "dbqNameInflexible":"form1[0].Page_7[0].TotalArea[3]",
      "pigmentation": {"hypo": [], "hyper": []},
      "dbqNamePigmentation":"form1[0].Page_7[0].TotalArea[1]",
      "section": {
         page: "6",
         title: "SCARS OR OTHER DISFIGUREMENT OF THE HEAD, FACE OR NECK",
         number: "C"
      },
      "questions": [
               {
                  "main":"Hypopigmentation",
                  "isHypoPigmentation": true,
                  "dbqNameAdditional":"form1[0].Page_6[0].AdditionalScars[3],form1[0].Page_7[0].ScarDisfigurement5[0]", //text,checkbox
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement5[5],form1[0].Page_7[0].Pigmentation[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement5[3],form1[0].Page_7[0].Pigmentation[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement5[2],form1[0].Page_7[0].Pigmentation[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement5[4],form1[0].Page_7[0].Pigmentation[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement5[1],form1[0].Page_7[0].Pigmentation[0]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Hyperpigmentation",
                  "isHyperPigmentation": true,
                  "dbqNameAdditional" : "form1[0].Page_7[0].AdditionalScars[3],form1[0].Page_7[0].ScarDisfigurement6[5]", //text,checkbox
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement6[0],form1[0].Page_7[0].Pigmentation1[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement6[2],form1[0].Page_7[0].Pigmentation1[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement6[3],form1[0].Page_7[0].Pigmentation1[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement6[1],form1[0].Page_7[0].Pigmentation1[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement6[4],form1[0].Page_7[0].Pigmentation1[0]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Induration and inflexibility",
                  "isInflexible": true,
                  "dbqNameAdditional":"form1[0].Page_7[0].AdditionalScars[1],form1[0].Page_7[0].ScarDisfigurement7[0]", //text,checkbox
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement7[5],form1[0].Page_7[0].Pigmentation2[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement7[3],form1[0].Page_7[0].Pigmentation2[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement7[2],form1[0].Page_7[0].Pigmentation2[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement7[4],form1[0].Page_7[0].Pigmentation2[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement7[1],form1[0].Page_7[0].Pigmentation2[0]",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Abnormal texture",
                  "isAbnormalTexture": true,
                  "dbqNameAdditional":"form1[0].Page_7[0].AdditionalScars[2],form1[0].Page_7[0].ScarDisfigurement8[5]", //text,checkbox
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement8[0],form1[0].Page_7[0].Pigmentation3[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement8[2],form1[0].Page_7[0].Pigmentation3[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement8[3],form1[0].Page_7[0].Pigmentation3[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement8[1],form1[0].Page_7[0].Pigmentation3[0]",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].ScarDisfigurement8[4],form1[0].Page_7[0].Pigmentation3[0]",
                        "answer" : "",
                     }
                  ]
               }
            ]
   },
   {
      "question":"Is there any scar tender to palpation or unstable upon inspection?",
      "sub":"Please SKIP this section if it does not applicable",
      "type":"disfigureQuestions",
      "show": false,
      "outer_refId":6,
      "scarsIndex":5,
      // "abnormalTexture":"",
      // "dbqNameAbnormalTexture":"",
      // "inflexible":"",
      // "dbqNameInflexible":"",
      // "pigmentation": {"hypo": [], "hyper": []},
      // "dbqNamePigmentation":"",
      "section": {
         page: "7",
         title: "SCARS OR OTHER DISFIGUREMENT OF THE HEAD, FACE OR NECK",
         number: "D,E"
      },
      "questions": [
               {
                  "main":"Are any of the scars tender to palpation?",
                  "dbqNameAdditional":"form1[0].Page_7[0].Listadditionalscars[0]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_7[0].Length[0]",
                        "type":"text",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].Length[1]",
                        "type":"text",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].Length[2]",
                        "type":"text",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].Length[3]",
                        "type":"text",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].Length[4]",
                        "type":"text",
                        "answer" : "",
                     }
                  ]
               },
               {
                  "main":"Are any of the scars unstable upon inspection?",
                  "dbqNameAdditional":"form1[0].Page_7[0].Listadditionalscars[1]",
                  "scars": [
                     {
                        "dbqName": "form1[0].Page_7[0].Length[5]",
                        "type":"text",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].Length[6]",
                        "type":"text",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].Length[7]",
                        "type":"text",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].Length[8]",
                        "type":"text",
                        "answer" : "",
                     },
                     {
                        "dbqName": "form1[0].Page_7[0].Length[9]",
                        "type":"text",
                        "answer" : "",
                     }
                  ]
               }
            ]
   },
   
   
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "show": true,
      "section": {
         page: "9",
         title: "REMARKS",
         number: "3"
      },
      "options":[],
      "maxLength":2100,
      "dbqName":"form1[0].Page_9[0].Remarksifany[0]",
      "answer":""
   },
]
   
    export default scars_questions ;